import { createFileRoute } from '@tanstack/react-router';
import ResetPasswordRequestPage from 'src/AkomiLoginPage/ResetPasswordPage/ResetPasswordRequestPage';

export const Route = createFileRoute('/reset-password/')({
  component: ResetPasswordRequestPage,
});
